<template>
   <div    class="news__firstserction" data-aos="fade-up" >
     <div class="bg_style_image">
       <img v-lazy="proxyUrl + post.jetpack_featured_media_url">
     </div>
      <div class="container">
        <div class="row">
          <div class="col-sm-6 col-xs-12  flex">
            <div class="full_image"  v-lazy:background-image="media" >
            </div>
          </div>
          <div class="col-sm-6">
            <div class="main_blog">
              <h1 v-html="post.title.rendered">
              </h1>
              <p v-html="post.excerpt.rendered">
              </p>
              <div class="date_icon">
                <img src="/static/cdn/date_h577wr.svg">
                <span>
                  {{ post.date | moment("MMM DD, YYYY ") }}
                  <!-- Apr 11 at 2:56 AM -->
                </span>
              </div>
              <router-link :to="'/news/show/'+ post.id + '/posts' "
                class="readmore_btn button button--transparent-grad pulse">
                <span>
                  Read more
                </span>
              </router-link>
            </div>
          </div>
        </div>
      </div>

    </div>
</template>

<script>
export default {
  data(){
    return{
          proxyUrl:"https://hanighannoum.nl/proxy.php?url="  ,
    }
  },
  props: {
        post: Object,
        media:String
        }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/News/Parts/pre_post.vue